import axios from '@axios'
import type { AxiosRequestConfig } from 'axios'
/**
 * Aquí se definen funciones auxiliares
 * que ayudan a definir un código mejor
 */
import { identity } from 'lodash'

// eslint-disable-next-line import/extensions
import NoObjectProvidedException from '../exceptions/NoObjectProvidedException'

export function just<T>(value?: Nullable<T>) {
    if (value === undefined || value == null) throw new NoObjectProvidedException()
    return value
}

// type Booleanish = true | false | number | null | undefined | object

// type Maybe<T> = {
//     // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
//     'elif': <U extends any = any>(expr: Booleanish | ((arg?: T) => Booleanish)) => Maybe<T | U>
//     // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
//     'else': <U extends any = any>(elseVal?: U) => U | T
//     'get': () => T
// }
// type MaybeBuilder<T> = {
//     'if': (expr: Booleanish | ((arg?: T) => Booleanish)) => Maybe<T>
// }

// export const maybe = <T>(value: T): MaybeBuilder<T> => ({
//     'if': (expr) => {
//         if (typeof expr == 'function'){
//         }
//     },
// })

type RequestBuildInfo<Actions> = (
    { method: 'GET' }
    | { method: 'POST' | 'PUT' | 'PATCH', asForm?: boolean }
    ) & {
        route: string,
        /**
         * Si se desea modificar el payload.
         *
         * @param param el payload original
         * @returns el nuevo payload a enviar
         */
        mapPayload?: (param: any) => any,
        action?: Actions
        axiosSettings?: AxiosRequestConfig
    }

// TODO: Add URI Builder for path
export class RequestBuilder<Actions> {
    private _routes: Record<string, RequestBuildInfo<Actions>>

    constructor(routes: Record<string, RequestBuildInfo<Actions>> = {}) {
        this._routes = routes
    }

    addRequest(requestName: string, settings: RequestBuildInfo<Actions>): RequestBuilder<Actions> {
        this._routes[requestName] = settings
        return this
    }

    addPost(requestName: string, settings: Omit<RequestBuildInfo<Actions>, 'method'>) {
        return this.addRequest(requestName, { ...settings, method: 'POST' })
    }

    qPost(requestName: string, endpoint: string, settings?: Omit<RequestBuildInfo<Actions>, 'method'>) {
        return this.addRequest(requestName, { ...settings, route: endpoint, method: 'POST' })
    }

    addPostForm(requestName: string, settings: Omit<RequestBuildInfo<Actions>, 'method' | 'asForm'>) {
        return this.addPost(requestName, { ...settings, asForm: true } as Omit<RequestBuildInfo<Actions>, 'method'>)
    }

    addPut(requestName: string, settings: Omit<RequestBuildInfo<Actions>, 'method'>) {
        return this.addRequest(requestName, { ...settings, method: 'PUT' })
    }

    qPut(requestName: string, endpoint: string, settings?: Omit<RequestBuildInfo<Actions>, 'method'>) {
        return this.addRequest(requestName, { ...settings, route: endpoint, method: 'PUT' })
    }

    addPatch(requestName: string, settings: Omit<RequestBuildInfo<Actions>, 'method'>) {
        return this.addRequest(requestName, { ...settings, method: 'PUT' })
    }

    addGet(requestName: string, settings: Omit<RequestBuildInfo<Actions>, 'method'>) {
        return this.addRequest(requestName, { ...settings, method: 'GET' })
    }

    qGet(requestName: string, endpoint: string, settings?: Omit<RequestBuildInfo<Actions>, 'method' | 'route'>) {
        return this.addGet(requestName, { ...settings, route: endpoint })
    }

    quick(requestName: string, endpoint: string, method: 'GET' | 'PUT' | 'PATCH' | 'POST') {
        return this.addRequest(requestName, { route: endpoint, method })
    }

    build(): Record<string, (ctx: any, p: any) => Promise<any>> {
        const out: Record<string, (ctx: any, p: any) => Promise<any>> = {}
        Object.entries(this._routes).forEach(([handler, config]) => {
            let fetchFunc: typeof axios.get | typeof axios.patch
            switch (config.method) {
                case 'GET':
                    fetchFunc = axios.get
                    break
                case 'PATCH':
                    fetchFunc = (config.asForm) ? axios.patchForm : axios.patch
                    break
                case 'PUT':
                    fetchFunc = (config.asForm) ? axios.putForm : axios.put
                    break
                case 'POST':
                    fetchFunc = (config.asForm) ? axios.postForm : axios.post
                    break
                default:
                    console.error(`Invalid settings for ${handler}: unknown method`)
            }
            const placeholders = config.route.match(/:\w+/)
            const transform = config.mapPayload ?? identity
            out[handler] = async function (context, params) {
                let { route } = config
                const send = { ...params }
                placeholders?.forEach(ph => {
                    const attrName = ph.replace(':', '')
                    route = route.replace(ph, params[attrName])
                    console.log('replacing: ', ph)
                    send[attrName] = undefined
                })
                const payload = config.method === 'GET' ? { params: transform(send) } : transform(send)
                const makeRequest = () => (
                    config.method === 'GET'
                        ? fetchFunc(route, { ...config.axiosSettings, ...payload })
                        : fetchFunc(route, payload, config.axiosSettings)
                )

                const response = await makeRequest()
                if (config.action) {
                    context.commit(config.action, response.data)
                }
                return response
            }
        })
        return out
    }
}

export function createRequestBuilder<A>(): RequestBuilder<A> {
    return new RequestBuilder()
}
